import { pageInfoFragment } from "@/components/Pagination/usePagination";
import { graphql } from "@/graphql";

export const bookingDateRangeQuery = graphql(`
  query BookingDateRange($businessUnit: ID!) {
    supplyChainBookings(owners: [$businessUnit], first: 1, sortBy: [{ field: PLANNED_SHIPPING_DATE, desc: false }]) {
      edges {
        node {
          plannedShippingDate
        }
      }
    }
    latestBookings: supplyChainBookings(
      owners: [$businessUnit]
      first: 1
      sortBy: [{ field: PLANNED_SHIPPING_DATE, desc: true }]
    ) {
      edges {
        node {
          plannedShippingDate
        }
      }
    }
  }
`);

export const sourcesSummaryQuery = graphql(
  `
    query SourcesSummary(
      $businessUnit: ID!
      $fromDate: Date!
      $toDate: Date!
      $sortBy: [SupplyChainBookingSummarySortByField!]
      $first: Int
      $last: Int
      $before: String
      $after: String
    ) {
      supplyChainBookingSourcesSummary(
        businessUnit: $businessUnit
        fromDate: $fromDate
        toDate: $toDate
        sortBy: $sortBy
      ) {
        connection(first: $first, last: $last, before: $before, after: $after) {
          pageInfo {
            ...PageInfo
          }
          edges {
            node {
              numHead
              numHeadBooked
              numHeadPlanned
              numHeadShipped
              supplyChainPartner {
                businessName
                id
                monthlyTarget
              }
            }
          }
          numPartners
        }
      }
    }
  `,
  [pageInfoFragment],
);

export const destinationsTotalsQuery = graphql(`
  query DestinationsTotals($businessUnit: ID!, $fromDate: Date!, $toDate: Date!) {
    supplyChainBookingDestinationsSummary(
      businessUnit: $businessUnit
      fromDate: $fromDate
      toDate: $toDate
      sortBy: []
    ) {
      totals {
        numHead
        numHeadBooked
        numHeadPlanned
        numHeadShipped
      }
    }
  }
`);

export const sourcesTotalsQuery = graphql(`
  query SourcesTotals($businessUnit: ID!, $fromDate: Date!, $toDate: Date!) {
    supplyChainBookingSourcesSummary(businessUnit: $businessUnit, fromDate: $fromDate, toDate: $toDate, sortBy: []) {
      totals {
        numHead
        numHeadBooked
        numHeadPlanned
        numHeadShipped
      }
    }
  }
`);
